// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"380":"608f65d6","2657":"cca8b70c","3054":"4ffba494","3233":"cca8b70c"}[chunkId] + ".chunk.css";
};